module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAASZJREFUWIXtltFNwzAURc+rGIAN8AhsQDcgG5ARugEdoUwQZYMyAWUDOgFhA5jg8lEnqpwYiOu0Anr+8p7ie54cxYYBJC2Vn81Q1myoeEwuIvUGeM6c9ZJ5vT+ChQVJC+AGuJwgbwM8mNn7YFfSeoKvP+RVUjfcbC/cAbcTTB3igKIn4BspfCRK9ARSqP1i29QFDhGozaz0H9Q8VSJVoDazUtK1fy5SJVIE2vASWPlalSoxVqDZC6+CXitR9N76gthZEMNJemI36RAVu3Pkx6RsQSy8xU0tkJWzwFng1wtcSbo/pYADlrkEmkMWGkmX1QmYWQM8HiH8DVh3uWHXX0rnTHcpXUUvpf+S3hYA+PP+LnPW1swWYTF2H3B8f+yOZXDYk/8JPwGcRAD8ao85twAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_wallet_back.png
// module id = 361
// module chunks = 1